import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addaccountMg from "./components/addaccountMg";
import { fbProductAccData, fbProductAccDel } from "@/api/financial/consumptionDetails";
import { tabulation } from "@/mixins/index";
import facebook from "./mixins/facebook";
export default {
  name: "accountMg",
  mixins: [tabulation, facebook],
  components: {
    addaccountMg: addaccountMg
  },
  data: function data() {
    return {
      tableData: [],
      reqLoading: false,
      searchData: {
        page: 1,
        page_size: 10
      },
      total: 0
    };
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    searchClick: function searchClick(e) {
      var _this = this;

      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      // if (!this.searchData.special_product_id.toString() && type) {
      //   this.$message.error('请选择产品')
      //   return
      // }else if(!this.searchData.special_product_id.toString() && !type){
      //   return
      // }
      if (!this.searchData.special_product_id.toString()) {
        this.searchData.special_product_id_all = this.productsListAll.map(function (i) {
          return i.id;
        });
      } else {
        this.searchData.special_product_id_all = this.searchData.special_product_id;
      }

      this.searchData.page = e ? e : this.searchData.page;
      var searchData = JSON.parse(JSON.stringify(this.searchData));
      searchData.ad_placement = searchData.ad_placement == 'valuets' ? [''] : searchData.ad_placement;
      this.reqLoading = true;
      fbProductAccData(searchData).then(function (res) {
        if (res.status == 200) {
          if (!res.data.data.length && e > 1) {
            _this.searchClick(e - 1);
          } else {
            var list = ['game', 'platform', 'channel', 'pkg', 'ad_channel', 'ad_placement'];
            _this.tableData = res.data.data.length ? _this.$utils.dataConversion(res.data.data, list) : [];
            _this.total = res.data.total;

            _this.$nextTick(function () {
              _this.getTableRight();
            });
          }
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    handleDelete: function handleDelete(ids) {
      var _this2 = this;

      // let id = ids.toString()
      this.$confirm("此操作将删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                fbProductAccDel({
                  id: ids.toString()
                }).then(function (res) {
                  if (res.status == 200) {
                    _this2.searchClick(_this2.searchData.page);

                    _this2.$message({
                      type: "success",
                      message: "删除成功!"
                    });
                  }
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    }
  }
};